module.exports = __webpack_public_path__ + "static/media/MovieRouletteRN.273f0125.png";